import './scss/mystyle.scss'

import { parse } from 'node-html-parser';


//console.log("%c KIOKO TEST: ACCESSING FROM PARCEL",'background: #000; color: hotpink, font-size: 44em; font-family: monospace;font-weight: bold; padding: 15px;');

//Products details customization
var productMain = document.querySelector('.product-main');

BuildProductDetails();

function splitLiteralBodyByCommas(input){
  var out = [];
  var iLen = input.length;
  var parens = 0;
  var state = "";
  var buffer = ""; //using string for simplicity, but an array might be faster

  for(var i=0; i<iLen; i++){
    if(input[i] == ',' && !parens && !state){
      out.push(buffer);
      buffer = ""; 
    }else{
      buffer += input[i];
    }
    switch(input[i]){
      case '(':
      case '[':
      case '{':
        if(!state) parens++;
        break;
      case ')':
      case ']':
      case '}':
        if(!state) if(!parens--)
          throw new SyntaxError("closing paren, but no opening");
        break;
      case '"':
        if(!state) state = '"';
        else if(state === '"') state = '';
        break;
      case "'":
        if(!state) state = "'";
        else if(state === "'") state = '';
        break;
      case '\\':
        buffer += input[++i];
        break;
    }//end of switch-input
  }//end of for-input
  if(state || parens)
    throw new SyntaxError("unfinished input");
  out.push(buffer);
  return out;
}

function BuildProductDetails(){
if(!productMain){
    console.warn('product-main doesnt exist');
    return;
}
//console.log('%c product-main exist', 'background: #222; color: #bada55');
let descriptionText = productMain.querySelector(".product-description").innerHTML;
if(!productMain.querySelector(".product-description")){
//    console.warn('product-main doesnt exist');
    return;
}
//console.log('%c product-description exist', 'background: #222; color: #bada55');
// console.log(productMain.children);
//console.log('%c [ default html ]' + descriptionText, 'color: #999');
//console.log('%c A consommer de préférence avant: exist > ' + descriptionText.includes('A consommer de préférence avant:'),'background: #000; color: hotpink');

// let testerArray = [].slice.call( descriptionText );
// console.log("testerArray = " + testerArray);

// const arr = [...descriptionText];
// console.log("arr = " + arr.length);

//Hide content
descriptionText = descriptionText.replace('<p>A consommer de préférence avant:  --</p>', '<p class="hide">A consommer de préférence avant:  --</p>');
descriptionText = descriptionText.replace('<p><br><br>Ingrédients:', '<p class="hide"><br><br>Ingrédients:');

//Blank Valeurs nutritionnelles
descriptionText = descriptionText.replace('<p>ENERGIE(KCAL)', '<p class="hide">ENERGIE(KCAL)');

//Preparations
descriptionText = descriptionText.replace('<ol>', '<span class="komoku">Préparation</span><br><ol class="preparation">');

//Ingrédients: 
descriptionText = descriptionText.replace('<p>Ingrédients: ', '<span class="komoku">Ingrédients</span><p class="allergenes">');

//Allergènes
descriptionText = descriptionText.replace('<p>Allergènes: ', '<span class="komoku">Allergènes</span><p class="allergenes">');

// Valeurs nutritionnelles pour 100g
descriptionText = descriptionText.replace('<p>Valeurs Nutritionnelles pour 100G: ', '<span class="komoku">Valeurs Nutritionnelles pour 100G</span><p class="komoku-vn-table">');

//descriptionText to array
let descriptionObject = descriptionText.match(/<[^>\r\n]+>|[^<>\r\n]+/g);
// console.log("descriptionObject = " + descriptionObject);
descriptionObject.forEach((item, index, object) => {
    item = item.trim();
    item = item.replace(/\&nbsp;/g, '');
    item = item.replace(/\u00a0/g, '');
    item = item.replace('<br>', '');
    item = item.replace('&nbsp;', '');

    if(item == "<br>"){
        object.splice(index, 1);
    }else if(item == "nbsp;"){
        object.splice(index, 1);
    }else if(item == ""){
        object.splice(index, 1);
    }
    //console.log(`${index}: ${item}`);
});
// console.log("descriptionObject = " + descriptionObject);
//join array to string
let descriptionListString = descriptionObject.join('');
//console.log("descriptionListString type = " + typeof(descriptionListString));

//Remove All empty tag
descriptionListString = descriptionListString.replace('<p> </p>', '');
descriptionListString = descriptionListString.replace('<p></p>', '');
descriptionListString = descriptionListString.replace('<p><br></p>', '');
descriptionListString = descriptionListString.replace('<p>&nbsp;</p>', '');
descriptionListString = descriptionListString.replace(/\&nbsp;/g, '');
descriptionListString = descriptionListString.replace('<p><br>', '<p>');

// console.log("descriptionListString = " + descriptionListString);
//console.log('%c [ Cleaned up html ]' + descriptionListString, 'background: #111; color: green');

productMain.querySelector(".product-description").innerHTML = descriptionListString;


//After css and js effected
//remove &nbsp;
if(document.querySelector('.preparation')){
    let preparationOL = document.querySelector('.preparation');
    preparationOL.innerHTML = preparationOL.innerHTML.replace(/\&nbsp;/g, '');

    //console.log('preparationOL = ' + preparationOL.innerHTML);
}

//add Element
let detailsEl = document.createElement('article');
detailsEl.classList.add('product--outer-details');

detailsEl.innerHTML = productMain.querySelector(".product-description").innerHTML;
// let komokuVnTable = document.createElement('div');
// komokuVnTable.classList.add('komoku-vn-table');
// komokuVnTable.innerHTML = ValeursNutritionnellesTable;
// detailsEl.appendChild(komokuVnTable);

let target = document.querySelector('.product--outer');
// console.log("target = " + target);
target.parentNode.insertBefore( detailsEl, target.nextSibling );


//komoku-vn-table

if(document.querySelector('.komoku-vn-table') != null){
    let ValeursNutritionnellesHTML = document.querySelector('.komoku-vn-table').innerHTML;
    //console.log("ValeursNutritionnellesHTML = " + ValeursNutritionnellesHTML);

    let ValeursNutritionnelles;

    if(ValeursNutritionnellesHTML.includes("---Dont") || ValeursNutritionnellesHTML.includes("Énergie")){
        // var regex = /,(?![^(]*)) /;
        // ValeursNutritionnelles = ValeursNutritionnellesHTML.split(",");
        ValeursNutritionnelles = splitLiteralBodyByCommas(ValeursNutritionnellesHTML);
    }else if(ValeursNutritionnellesHTML.includes("-")){
        ValeursNutritionnelles = ValeursNutritionnellesHTML.split("-");
    }
    
    //console.log("ValeursNutritionnelles = " + ValeursNutritionnelles);

    let ValeursNutritionnellesArray = [];
    
    if(ValeursNutritionnelles){
        ValeursNutritionnelles.forEach(item => {

            //console.log("unit = " + unit);
            //console.log("item = " + item);
            let unit = item.substring(
                item.lastIndexOf("(") + 1, 
                item.lastIndexOf(")")
                );
            let removeDefaultUnit = "("+ unit +")";
            //console.log("removeDefaultUnit = " + removeDefaultUnit);
            item = item.replace(removeDefaultUnit, '');
            

            item = item.replace(/\&nbsp;/g, '');
            
            if(ValeursNutritionnellesHTML.includes("---Dont") ||    ValeursNutritionnellesHTML.includes("Énergie")){
                item = item.replace(/\---/g, '');
            }
            var last2words = item.replace(/\ /g, '').slice(-2);
            // console.log("item = " + item);
            // console.log("last2words = " + last2words);
            if(ValeursNutritionnellesHTML.includes("---Dont") || ValeursNutritionnellesHTML.includes("Énergie")){
                // console.log("is not default table");
                // let itemName = parseInt(item.replace(/[^0-9\.]/g, ''), 10);
                item = "<li><div>" + item + '</div><div>' + unit + "</div></li>";

            }else{
                if(last2words === "NC" || last2words === "nc"){
                    item = item.replace(':', '</div><div class="nc">');
                }else{
                    item = item.replace(':', '</div><div>');
                }
                
                if(last2words === "NC" || last2words === "nc"){
                    item = "<li><div>" + item + "</div></li>";
                }else{
                    item = "<li><div>" + item + unit + "</div></li>";
                }
            }
            //console.log("unit = " + unit);
            //console.log("item = " + item);
            ValeursNutritionnellesArray.push(item);
        
        });

        let ValeursNutritionnellesTable = "<ol>" + ValeursNutritionnellesArray.join('') + "</ol>";

        // console.log('ValeursNutritionnellesTable = ' + ValeursNutritionnellesTable);

        let komokuVnTables = document.querySelectorAll('.komoku-vn-table');

        [].forEach.call(komokuVnTables, function(komokuVnTables) {
            komokuVnTables.innerHTML = ValeursNutritionnellesTable;
        });

    }
}


// console.log("test");

productMain.querySelector(".product-description").style.display = 'none';
// document.querySelector(".gallery-navigation--scroller").style.display = 'none';

//change price place
let price = document.querySelector(".product--price .price--main span.money").innerHTML;
// console.log("price = " + price);
let priceNewPlace = document.querySelector(".product-form-price span");
priceNewPlace.innerHTML = price;

let compare = document.querySelector(".product--price .price--compare-at span.money").innerHTML;
console.log("compare = " + compare);
if(compare){
  let compareNewPlace = document.querySelector(".product-form-compare .price--compare-at span.money");
  compareNewPlace.innerHTML = compare;
}else{
  document.querySelector(".product-form-compare").style.display = 'none';
}

//add info units per price
let totalquantity = document.querySelector('.product--unit-price span.product--total-quantity').innerHTML;
let unitPriceAmmount = document.querySelector('.product--unit-price span.product--unit-price-amount').innerHTML;
let unitPriceMeasure = document.querySelector('.product--unit-price span.product--unit-price-measure').innerHTML;

// console.log("totalquantity = " + totalquantity);
// console.log("unitPriceAmmount = " + unitPriceAmmount);
// console.log("unitPriceMeasure = " + unitPriceMeasure);

//move units to new area
if(unitPriceAmmount){
    let newUnits = document.querySelector('.product-form-all p.units');
    console.log(unitPriceAmmount + "/" + unitPriceMeasure);
    newUnits.innerHTML = unitPriceAmmount + "/" + unitPriceMeasure;
}

//if product SKU exist change word UGC to SKU
let SKUels = document.querySelector('.product-sku strong');
if(SKUels){
    SKUels.innerHTML = "REF:";
}
//add total weight if exist
let productPriceOriginalElement = document.querySelector('.product-pricing');
if(totalquantity){
    let weightEl = document.createElement('div');
    weightEl.classList.add('product-weight');
    weightEl.innerHTML = "<strong>POIDS: </strong><span>" + totalquantity + "</span>";
    productPriceOriginalElement.parentNode.insertBefore( weightEl, productPriceOriginalElement.nextSibling );
}


//structure details
// descriptionText = parse(descriptionText);
// console.log(descriptionText.structure);
// // console.log(JSON.stringify(descriptionText));
// console.log("type = " + typeof(descriptionText));


}


//Cart delete Btns
// var buttonsCartListDeleteBtns = document.querySelectorAll('.cart-item--remove .cart-item--remove-link');

// for (let i = 0; i < buttonsCartListDeleteBtns.length; i++) {
//   buttonsCartListDeleteBtns[i].addEventListener('click', function(e) {
//     e.preventDefault();
//     // e.stopPropagation();
//     $.ajax({
//     url: '/cart.js',
//     dataType: 'json'
//     })
//     .done(function(data){
//       const newWeight = (Math.trunc(data.total_weight) / 1000 ) + " kg";
//       console.log("data.total_weight =" + newWeight);
//     });

//   }, true);
// }

//Cart quantity:qty buttons

var buttonsQTYMinus = document.querySelectorAll('.form-field--qty-input .btn-qty.minus');

for (let i = 0; i < buttonsQTYMinus.length; i++) {
  buttonsQTYMinus[i].addEventListener('click', function(e) {
    this.parentNode.querySelector('.form-field-input').stepDown();
    // e.preventDefault();
    // e.stopPropagation();
  }, true);
}

var buttonsQTYPlus = document.querySelectorAll('.form-field--qty-input .btn-qty.plus');

for (let k = 0; k < buttonsQTYPlus.length; k++) {
  buttonsQTYPlus[k].addEventListener('click', function(e) {
    this.parentNode.querySelector('.form-field-input').stepUp();
    // e.preventDefault();
    // e.stopPropagation();
  }, true);
}

/* Recompense 
If GDPR bar exist move heigher
*/
//.smile-ui-lite-container

//Obeserve recompenses button loaded

const checkRecompensesButton = setInterval(function(){
  const buttonEl = document.querySelector('#smile-ui-container');
  const buttonEl2 = document.querySelector('#smile-ui-lite-container');

  if(buttonEl){
    // console.log(buttonEl);
    buttonEl.style.cssText += 'z-index: 9000 !important';
    clearInterval(checkRecompensesButton);
  }
  if(buttonEl2){
    // console.log(buttonEl2);
    buttonEl2.style.cssText += 'z-index: 9000 !important';
  }
  // console.log("checking Recompenses button...");
}, 1000);

//MutationObserver test :: not working...TypeError: Failed to execute 'observe' on 'MutationObserver': parameter 1 is not of type 'Node'.
// window.addEventListener('DOMContentLoaded', function(e){

//   // const buttonRecompenseEl = document.querySelector('#smile-ui-lite-container');
//   let buttonRecompenseEl = $("#smile-ui-lite-container")[0];
//   // const buttonEl =  $("#smile-ui-lite-container")[0];

//   const RecompenseObserver = new MutationObserver(function(mutations){
//     mutations.forEach(function (mutation){
//       if(mutation.addedNodes.length){
//         console.log(mutation.addedNodes[0]);
//       }
//     });
//   });
//   RecompenseObserver.observe(buttonRecompenseEl, {
//     childList: true
//   });
//   }, {once: true});

// var buttonEl;
// var buttonElChild;

// const RecompenseObserver = new MutationObserver(function(mutations){
//   mutations.forEach(function (mutation){
//     if(mutation.addedNodes.length){
//       console.log("Added", mutation.addedNodes[0]);
//       buttonEl.style.cssText += 'z-index: 9000 !important';
//     }
//     if(mutation.removedNodes.length){
//       console.log("Removed", mutation.removedNodes[0]);
//     }
//   });
// });

// function addObserverIfDesiredNodeAvailable() {
//   buttonEl = $("#smile-ui-lite-container")[0];
//   buttonElChild = $("#smile-lite-launcher-frame")[0];
//   console.log("check..");
//     if(!buttonElChild) {
//         //The node we need does not exist yet.
//         //Wait 500ms and try again
//         console.log("recompenses button not available yet..");
//         window.setTimeout(addObserverIfDesiredNodeAvailable,500);
//         return;
        
//     }else{
//       buttonEl.style.cssText += 'z-index: 9000 !important';
//       console.log(buttonEl);
//       console.log("recompenses button available:zIndex changed!");
//       RecompenseObserver.observe(buttonElChild, {
//         childList: true,
//         subtree: true,
//         characterDataOldValue: true
//       });
//     }
// }
// addObserverIfDesiredNodeAvailable();

